import BaseService from './base'

export default class ActivityLogService extends BaseService {
  static resource() {
    return 'api/v1/activity_logs'
  }
}
